<template>
	<div class="modContainer">
		<div class="qrCodeContainer">
			<div class="qrCodeimgContainer">
				<img v-if="qrcodeImgBase64" class="qrCodeimg" :src="qrcodeImgBase64" alt="">
				<i v-else class="mbm-iconfont mbm-xiazai42"></i>
				<div v-if="qrcodeCreateing" class="qrcode-create-loading-item"><div class="loader-defult-yjdhw-38"></div></div>
			</div>
			<div class="qrCodebtns"> 
				<a-button @click="uploadLogoQrcodeBeautifyFuncBtn" class="btnsMargin">上传LOGO</a-button>
				<!-- <input v-show="false" ref="logoQrcodeRef" type="file" accept="image/jpg,image/jpeg,image/png" @change="logoQrcodeChange($event)"> -->
				<a-button @click="qrcodeBeautifyFuncBtn" class="btnsMargin">二维码美化</a-button>
			</div>
		</div>
		<div v-if="codeType>0">
			<div style="margin-bottom: 22px;">
				<p class="setTitle">打开方式<!-- <span>查看样例</span> --></p>
				<div class="openType">
					<div @click="setOpenType(1)" :class="useSetdata.openType==1?'operateActive':''">
						<img class="openTypeImg open__defult__logo__img" src="/img/defult_chat.png?t=2" >
						<text>微微小程序</text>
						<span v-if="useSetdata.openType==1" class="mbm-iconfont mbm-sanjiaogou1 yjy-gou-rb-box"></span>
					</div>
					<div @click="setOpenType(2)" :class="useSetdata.openType==2?'operateActive':''">
						<img class="openTypeImg" src="/img/chat.png" >
						<text>无标识小程序</text>
						<span v-if="useSetdata.openType==2" class="mbm-iconfont mbm-sanjiaogou1 yjy-gou-rb-box"></span>
						<span class="mbm-iconfont mbm-VIP11 vip-logo-icon" ></span>
					</div>
					<div @click="setOpenType(3)" :class="useSetdata.openType==3?'operateActive':''">
						<img class="openTypeImg" src="/img/h5.png" >
						<text>H5网页</text>
						<span v-if="useSetdata.openType==3" class="mbm-iconfont mbm-sanjiaogou1 yjy-gou-rb-box"></span>
						<span class="mbm-iconfont mbm-VIP11 vip-logo-icon" ></span>
					</div>
				</div>
			</div>
			<!-- ↓↓高度57px↓↓ -->
			<div v-if="false" >
				<p class="setTitle">视频款式<span @click="showVideotypeModal" style="display: none;">查看样例</span></p>
				<div class="videoType">
					<div @click="setStyleType(1)" :class="useSetdata.styleType==1?'operateActive':''">
						<text>标准</text>
						<span v-if="useSetdata.styleType==1" class="mbm-iconfont mbm-sanjiaogou1 yjy-gou-rb-box"></span>
					</div>
					<div @click="setStyleType(2)" :class="useSetdata.styleType==2?'operateActive':''">
						<text>视频集</text>
						<span v-if="useSetdata.styleType==2" class="mbm-iconfont mbm-sanjiaogou1 yjy-gou-rb-box"></span>
					</div>
					<div @click="setStyleType(3)" :class="useSetdata.styleType==3?'operateActive':''">
						<text>视频刷一刷</text>
						<span v-if="useSetdata.styleType==3" class="mbm-iconfont mbm-sanjiaogou1 yjy-gou-rb-box"></span>
					</div>
				</div>
			</div>
			<div class="detailSet" v-if="codeType==1">
				<div>
					<p class="detailSet1">下载设置<span @click="openDownloadset">点击设置</span></p>
					<div class="detailSetDesc">可设置视频是否允许下载</div>
				</div>
			</div>
			<!-- <div class="detailSet" v-if="codeType==4">
				<div>
					<p class="detailSet1">文件直接打开<span @click="openOpenset">点击设置</span></p>
					<div class="detailSetDesc">可设置扫码文件是否直接打开</div>
				</div>
			</div> -->
			<div class="detailSet" v-if="codeType==3">
				<div>
					<p class="detailSet1">显示设置<span @click="openimgSet">点击设置</span></p>
					<div class="detailSetDesc">可设置图片排序及展示方式</div>
				</div>
			</div>
			<div>
				<p class="detailSet1">二维码详细设置<span @click="openQrcodeSet">点击设置</span></p>
				<div class="detailSetDesc">可设置：{{codeType==4?'二维码查看权限，底部设置，下载权限等':'二维码查看权限，底部设置'}}</div>
			</div>
			
		</div>
		<div v-else class="qrcode-beatful-box">
			<div class="qrcode-beatful-item">
				<label class="qrcode-beatful-item-left">容错
					<a-popover title="" placement="right">
					    <template #content>容错率越高，二维码可遮挡部分越多</template>
					    <span class="mbm-iconfont mbm-wenhao-xianxingyuankuang"></span>
					</a-popover>
				</label>
				<a-select ref="select" size="small"
				      v-model:value="qrcodeConfig.level"
					  @change="handleChangeCodeLevel"
				      style="width: 150px">
						<template #suffixIcon>
							<Icon>
							    <template #component>
									<svg t="1655264345662" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7991" width="10" height="10"><path d="M946.4 353.50000001l-419.9 419.9c-8.2 8.2-21.5 8.2-29.7 0l-421.1-421.1c-16.4-16.4-16.4-43 0-59.3 16.4-16.4 43-16.4 59.3 0L504.2 662.20000001c4.1 4.1 10.7 4.1 14.8 0l368-368c16.4-16.4 43-16.4 59.3 0 16.5 16.3 16.5 42.9 0.1 59.3z" fill="#8a8a8a" p-id="7992"></path></svg>
								</template>
							</Icon>
						</template>
				      <a-select-option value="L">最低(可遮7%)</a-select-option>
				      <a-select-option value="M">低(可遮15%)</a-select-option>
				      <a-select-option value="Q">中等(可遮25%)</a-select-option>
				      <a-select-option value="H">高(可遮30%)</a-select-option>
				</a-select>
			</div>
			<div class="qrcode-beatful-item">
				<label class="qrcode-beatful-item-left">尺寸</label>
				<a-select size="small"
				      v-model:value="qrcodeConfig.bgwidth"
					  @change="handleChangeCodeSize"
				      style="width: 150px">
						<template #suffixIcon>
							<Icon>
								<template #component>
									<svg t="1655264345662" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7991" width="10" height="10"><path d="M946.4 353.50000001l-419.9 419.9c-8.2 8.2-21.5 8.2-29.7 0l-421.1-421.1c-16.4-16.4-16.4-43 0-59.3 16.4-16.4 43-16.4 59.3 0L504.2 662.20000001c4.1 4.1 10.7 4.1 14.8 0l368-368c16.4-16.4 43-16.4 59.3 0 16.5 16.3 16.5 42.9 0.1 59.3z" fill="#8a8a8a" p-id="7992"></path></svg>
								</template>
					  	    </Icon>
						</template>
				      <a-select-option value="200">200*200 像素</a-select-option>
				      <a-select-option value="400">400*400 像素</a-select-option>
				      <a-select-option value="500">500*500 像素</a-select-option>
				      <a-select-option value="1000">1000*1000 像素</a-select-option>
				      <!-- <a-select-option value="-1">自定义</a-select-option> -->
				</a-select>
			</div>
			<!-- <div class="qrcode-beatful-item">
				<a-input placeholder="输入自定义尺寸" size="small" style="width: 150px;margin-left: 60px;"></a-input>
			</div> -->
			<a-button @click="downloadBase64ToLocal" style="margin-top: 15px;" type="primary" size="large" block>下载图片</a-button>
			<div @click="downloadOrtherExtData.openDownloadOrtherExt" class="download-orther-ext-jxuhs">下载其他格式</div>
		</div>
		<a-modal :confirm-loading="downlodsetLoading" :destroyOnClose="true"  width="650"  cancelText="取消" okText="确认" :centered="true" :visible="downloadModVisible" @ok="handleOkDownlod" @cancel="handleCancleDownlod" title="下载设置" wrapClassName="full-modal">
			<downloadSet @setdownloadData="setdownloadData" :downlodGlobal="downlodGlobal" :downlodLocal="downlodLocal"></downloadSet>
		</a-modal>
		<a-modal :confirm-loading="opensetLoading" :destroyOnClose="true"  width="650"  cancelText="取消" okText="确认" :centered="true" :visible="openModVisible" @ok="handleOkOpen" @cancel="handleCancleOpen" title="打开方式设置" wrapClassName="full-modal">
			<openset @setopenData="setopenData" :openGlobal="openGlobal" :openLocal="openLocal"></openset>
		</a-modal>
		<a-modal :confirm-loading="imgconfirmLoading"  :bodyStyle="bodyStyle" width="800" :destroyOnClose="true"  cancelText="取消" okText="确认" :centered="true" :visible="imgsetModVisible" @ok="handleOkImgset" @cancel="handleCancleImgset" title="图片设置" wrapClassName="full-modal">
				<imgSet @setimgPrese="setimgPrese" @setimgStyle="setimgStyle" :pagedata="pagedata" :imgPrese="pagedata.content_html.img_prese" :imgStyle="pagedata.content_html.img_style"></imgSet>
		</a-modal>
	
		<!-- 二维码详细设置 -->
		<a-modal :destroyOnClose="true" :footer="null" :centered="true" width="1000px" :visible="qrcodeSetConfig.showDetailSet" title="设置" @cancel="qrcodeSetCancel" @ok="qrcodeSetOk">
			<div class="preview_wrap">
				<settings  :styleConfig="qrcodeSetConfig.styleConfig" :showConfig="qrcodeSetConfig.showConfig"  @getsetData="getQrcodeSetData"  :idKey="qrcodeSetConfig.id_key"></settings>
			</div>
		</a-modal>
		<!-- 二维码美化 -->
		<a-modal wrapClassName="beautifyModal" :mask="true" :destroyOnClose="true" :footer="null"  :centered="true" :visible="qrcodeBeautyData.beautyshow"  @cancel="qrcodeBeautyData.beautifyCancle" :title="qrcodeBeautyData.title">
			<beautifyMod :beautyStepInit="qrcodeBeautyData.beautyStepInit" :qrcodeContentData="qrcodeBeautyData.qrcodeContentData" @complete="qrcodeBeautyData.completeFunc" @change="qrcodeBeautyData.changeFunc"></beautifyMod>
		</a-modal>
		<!-- 下载其他格式 -->
		<a-modal width="1000" wrapClassName="downloadImgModal" :mask="true" :closable="false" :destroyOnClose="true" :footer="null" :centered="true" :visible="downloadOrtherExtData.visible"  title="">
			<downloadImg @closedownloadimg="downloadOrtherExtData.closeDownloadOrtherExt" :qrcodeInfo="downloadOrtherExtData.qrcodeInfo"></downloadImg>
		</a-modal>
	</div>
</template>

<script>
	import downloadSet from './downloadSet.vue';
	import openset from './openset.vue';
	import settings from './settings.vue';
	import imgSet from './imgSet.vue';
	import beautifyMod from './beautifyMod';
	import { message } from 'ant-design-vue';
	import downloadImg from './downloadImg';
	
	import { Download } from '../assets/js/download.js';
	import config from "../config/config.js";
	import baseFunc from '../config/base_func.js';
	import { v4 as uuidv4 } from 'uuid';
	import Icon from '@ant-design/icons-vue';
	
	export default {
		name: 'setMod',
		props: {
			setData:Object,
			codeType:Number, //1视频，2高级，3图片，4文件,5导航，6wifi，7表单，8音频，9网址,10
			qrcodeContent:{
				type:Object,
				default:{
					qrcode_type: "text",//video audio file image
					topCurrent: 1,
					content: "",//xx.com
					id_key:"",
					create_init:1,/*1：当前新增 2：当前修改*/
				}
			},
			pagedata:Object,
			title:String,
			id_key:String
		},
		components: {
			downloadSet,imgSet,Icon,settings,openset,beautifyMod,downloadImg
		},
		data() {
			return {
				downloadOrtherExtData:{
					visible:false,
					qrcodeInfo:{
						config:null,
						content:"",
						id_key:"",
						base64:null,
						name:"",
					},
					openDownloadOrtherExt:()=>{
						if(!this.qrcodeImgBase64){
							message.warning('请先生成二维码');
							return false;
						}
						this.downloadOrtherExtData.qrcodeInfo.config = JSON.parse(JSON.stringify(this.qrcodeConfig));
						this.downloadOrtherExtData.qrcodeInfo.content = this.qrcodeContent.content;
						if(typeof this.qrcodeContent.id_key !="undefined" && this.qrcodeContent.id_key){
							this.downloadOrtherExtData.qrcodeInfo.id_key = this.qrcodeContent.id_key;
						}
						this.downloadOrtherExtData.visible = true;
					},
					closeDownloadOrtherExt:()=>{
						this.downloadOrtherExtData.visible = false;
					},
				},
				qrcodeBeautyData:{
					title:"二维码美化",
					beautyshow:false,/*美化窗口开启-关闭*/
					beautyStepInit:1,/*美化步骤*/
					qrcodeContentData:{
						qrcode_type:"text",/*二维码类型*/
						id_key:"",/*二维码id_key*/
						content:"",/*二维码内容*/
						config:null,/*二维码参数*/
						moban_id:0,/*模板id*/
					},
					beautifyCancle:()=>{
						this.qrcodeBeautyData.beautyshow=false;
					},
					beautifyOpen:(type)=>{
						if(type=="logo"){
							this.qrcodeBeautyData.beautyStepInit=2
						}else{
							this.qrcodeBeautyData.beautyStepInit=1
						}
						let qrcodeBeautyTmpData ={
							qrcode_type:"text",/*二维码类型*/
							id_key:"",/*二维码id_key*/
							content:"",/*二维码内容*/
							config:null,/*二维码参数*/
						};
						if(this.qrcodeContent && this.qrcodeContent.content){
							if(this.qrcodeContent.qrcode_type)qrcodeBeautyTmpData.qrcode_type = this.qrcodeContent.qrcode_type
							if(this.id_key)qrcodeBeautyTmpData.id_key = this.id_key
							if(this.qrcodeContent.content)qrcodeBeautyTmpData.content = this.qrcodeContent.content
							if(this.qrcodeConfig)qrcodeBeautyTmpData.config = this.qrcodeConfig
						}
						this.qrcodeBeautyData.qrcodeContentData= JSON.parse(JSON.stringify(qrcodeBeautyTmpData));
						this.qrcodeBeautyData.beautyshow=true
					},
					completeFunc:(e)=>{
						// console.log("complete",e)
						this.qrcodeConfig = JSON.parse(JSON.stringify(e.config));
						this.qrcodeConfig.text = this.qrcodeContent.content;
						this.qrcodeConfig.bgwidth = this.$baseFunc.handleInt(this.qrcodeConfig.bgwidth);
						this.qrcodeBeautifyFunc.tempInit(this.qrcodeConfig)
						this.qrcodeBeautyData.beautifyCancle();
					},
					changeFunc:(e)=>{
						// console.log("change",e)
					}
				},
				qrcodeSetConfig:{
					id_key:'',
					showDetailSet:false,/*显示二维码设置*/
					styleConfig: {//样式设置，可不填
						iframe: {
							// width:'200px',//默认320px
							// height:'400px',//默认900px
							//...
						},
						settings: {
							// width:'300px',//默认500px
							//...
						}
					},
					showConfig: {//显示内容设置，可不填
						iframe: true, //显示左侧预览iframe
						settings: true, //显示右侧设置整体
						settings_qrcode: true, //设置头部二维码图片+标题
						settings_list: true, //二维码设置部分收起/展开
						settings_list_expire: true, //设置有效期
						settings_list_auth: true, //设置查看权限
						settings_list_open: true, //设置打开方式（链接类型此项不论设置什么值最终都为false）
						settings_list_bot: true, //底部设置
						settings_list_video: true, //视频下载设置
						settings_list_file_download:true,//文件下载设置
						settings_list_file_nonstop:true,//文件直达
						settings_extra: {
							show:false,
							title:"",
							content:{
								text:'',
							}
						},
					},
				},
				qrcodeCreateing:false,/*二维码生成长*/
				downlodsetLoading:false,
				opensetLoading:false,
				imgconfirmLoading:false,
				bodyStyle:{
					padding:0
				},
				// imgPrese:1,//图片展示样式
				// imgStyle:1,
				imgPresecurrent:1,
				imgStylecurrent:1,
				downlodGlobal:0,
				downlodLocal:0,
				openGlobal:0,
				openLocal:0,
				downloadModVisible:false,
				openModVisible:false,
				imgsetModVisible:false,
				download : new Download(),
				qrcodeBeautifyFunc:null,
				qrcodeImgBase64:"",/*二维码美化base64图片信息*/
				qrcodeConfig:{
                    transparent:false,
                    background: null,/*背景图片*/
                    backgroundkey: "",/*背景图片请求秘钥*/
                    backgroundold: null, /*背景图片 本地上传或者本地选择*/
                    bgColor: "#ffffff",/*二维码背景色*/
                    bgwidth: 400,/*背景图片尺寸*/
                    width: 400,/*二维码大小*/
                    point_type:0,/*码点样式*/
                    content: null,/*中心部分 文字内容*/
                    ewmleft: 0,/*二维码放入框距离左边距离*/
                    ewmtop: 0,/*二维码放入框距离顶部距离*/
                    fgColor: "#000000",/*二维码颜色*/
                    fontEffect: "default",/*文字特效*/
                    fontFamily: "KaiTi_GB2312",/*文字字体*/
                    fontSize: 22,/*文字大小*/
                    fontleft: 0,/*文字坐标 距离左边的位置*/
                    fonttop: 0,/*文字左边 距离顶部的位置*/
                    foreground: null,/*前景图片*/
                    foregroundold: null,/*前景图片 本地上传logo*/
                    ftColor: null,/*文字颜色*/
                    gcColor: null,/*二维码渐变色*/
                    gradientWay: "0",/*二维码渐变方式*/
                    level: "M",/*容错率*/
                    logoType: "default",/*logo效果*/
                    logoimgold: null,/*本地上传logo Or 选择本地*/
                    logoimg: null,/*logo图片地址*/
                    logoleft: -100,/*logo位置 距离左边*/
                    logotop: -100,/*logo位置 距离右边*/
                    logowidth: 0, /*logo宽度*/
                    logoheight: 0,/*logo高度*/
                    margin: 10, /*二维码外边距*/
                    max: 2000,
                    maxwidth: 2000,
                    nowwidth: 0,
                    paintColor: "#000000",
                    eys_use_color:true,/*是否图片填充码眼*/
                    pinType: 0,/*码眼样式*/
                    inptColor: null,/*码眼内框颜色*/
                    ptColor: null,/*码眼外框颜色*/
                    isWater: false,
                    rotate: 0,/*二维码旋转角度*/
                    round: 0, /*液态 直角 圆点*/
                    text: "http://www.wwei.cn",/*二维码内容*/
                    codetype:'qr',//码制
                },
				useSetdata:this.setData,
				global_set_config:{},
				set_config:{},
				userDefultSet:{},//用户默认打开方式
			}
		},
		
		mounted() {
		    document.addEventListener('keydown', this.saveContent)
		},
		beforeDestroy() {
		    document.removeEventListener('keydown', this.saveContent)
			
		},
		watch: {
			qrcodeContent: {
				deep: true,
				handler(newval, oldval) {
					if(newval.content){
						if(this.qrcodeBeautifyFunc){
							this.qrcodeBeautifyFunc.changeText(newval.content);
						}else{
							this.qrcodeConfig.text = newval.content;
							this.beautifyQrcodeFunc()
						}
					}else{
						this.qrcodeImgBase64 = ""
					}
				}
			},
			qrcodeImgBase64:{
				deep: true,
				handler(newval, oldval) {
					
					this.$emit('setqrImg',newval)
				}
			}
		},
		created() {
			this.getUserDefultSet().then(res=>{}).catch(err=>{})
			this.getDefultBeautifyTpl();
		},
		methods:{
			/*获取用户默认美化模板*/
			getDefultBeautifyTpl(){
				this.$apiRequest.post('/api/beautify/getDefultBeautifyTpl',{
					
				}).then(res=>{
					this.qrcodeConfig = res.data.config
				}).catch(err=>{
				})
			},
			//获取用户默认打开方式
			getUserDefultSet(){
				const self = this;
				return new Promise(function(resolve, reject) {
					self.$apiRequest.post('/qrcode/create/getUserDefultSet',{
						
					}).then(res=>{
						self.useSetdata.openType=res.data.data.mode;
						self.userDefultSet=res.data.data;
						resolve(res.data.data)
					}).catch(err=>{
						reject(err.data)
					})
				})
			},
			/*打开二维码设置*/
			openQrcodeSet(){
				if(!this.id_key){
					message.error('请先生成二维码！');
				}else{
					this.qrcodeSetConfig.id_key=this.id_key;
					this.qrcodeSetConfig.showDetailSet = true;
				}
			},
			/*关闭二维码设置*/
			qrcodeSetCancel(){
				this.qrcodeSetConfig.showDetailSet = false;
				this.qrcodeSetConfig.id_key="";
			},
			/*确认并关闭二维码设置*/
			qrcodeSetOk(){
				this.qrcodeSetConfig.showDetailSet = false;
				this.qrcodeSetConfig.id_key="";
			},
			/*设置二维码后回调信息*/
			getQrcodeSetData(res){
				// console.log(res.set_config.mode)
				this.useSetdata.openType=res.set_config.mode;
			},
			setdownloadData(e){
				this.downlodGlobal=e.usedownlodGlobal;
				this.downlodLocal=e.usedownlodLocal;
			},
			setopenData(e){
				this.openGlobal=e.useopenGlobal;
				this.openLocal=e.useopenLocal;
			},
			setimgPrese(e){
				// this.imgPrese=e
				this.pagedata.content_html.img_prese=e
			},
			setimgStyle(e){
				// this.imgStyle=e
				this.pagedata.content_html.img_style=e
			},
			openimgSet(){
				// if(!this.id_key){
				// 	message.error('请先生成二维码！');
				// }else{
				// 	this.imgsetModVisible=true;
				// }
				this.imgsetModVisible=true;
			},
			handleCancleImgset(){
				this.imgsetModVisible=false;
				this.pagedata.content_html.img_prese=this.imgPresecurrent;
				this.pagedata.content_html.img_style=this.imgStylecurrent;
			},
			//图片设置确定后上传数据修改二维码（修改）
			handleOkImgset(){
				// this.imgconfirmLoading=true;
				var data={
					name: "image",/*类型 文件：file 图片：image 视频：video 音频：audio*/
					component_code: "image",/*类型 文件：file 图片：image 视频：video 音频：audio*/
					sort: 0,
					content_html:{
						types: "image",/*类型 文件：file 图片：image 视频：video 音频：audio*/
						auto_increment: this.pagedata.content_html.lists.length,//(lists.length)
						img_prese: this.pagedata.content_html.img_prese,/*图片展示设置 1：平铺 2：轮播 3：轮播切片*/
						img_style: this.pagedata.content_html.img_style,/*图片样式设置 1：留白 2：撑满 3：置顶撑满*/
						lists: this.pagedata.content_html.lists
					}
				}
				this.$emit('setImgsetdata',data);
				this.imgsetModVisible=false;
				this.imgPresecurrent=this.pagedata.content_html.img_prese;//设置临时值
				this.imgStylecurrent=this.pagedata.content_html.img_style;//设置临时值
				// return false;
				
				// this.$apiRequest.post('/qrcode/create/createQrcodeIndex',{
				// 	content:JSON.stringify(data),
				// 	mode:this.setData.openType,
				// 	id_key:this.id_key,
				// 	title:this.title
				// }).then(res => {
				// 	console.log(res)
				// 	if(res.data.code==200){
				// 		this.imgconfirmLoading=false;
				// 		this.imgsetModVisible=false;
				// 		message.success(res.data.message);
						
				// 	}else{
				// 		this.$baseFunc.checkState(res.data).then(res => {
				// 			toGenerate()
				// 		});
				// 	}
				// }).catch(err => {
				// 	this.$baseFunc.checkState(err.data);
				// });
				// this.imgsetModVisible=false;
			},
			handleCancleDownlod(){
				this.downloadModVisible=false;
			},
			handleCancleOpen(){
				this.openModVisible=false;
			},
			handleOkDownlod(){
				this.setDownloadset();
			},
			handleOkOpen(){
				this.setOpenset();
			},
			openDownloadset(){
				if(!this.id_key){
					message.error('请先生成二维码！');
				}else{
					this.getDownloadset();
					this.downloadModVisible=true;
				}
			},
			openOpenset(){
				if(!this.id_key){
					message.error('请先生成二维码！');
				}else{
					this.getDownloadset();
					this.openModVisible=true;
				}
			},
			getDownloadset(type){
				this.$apiRequest.post('/qrcode/create/changeSet',{
					type:1,//1查询2修改
					id_key:this.id_key
				}).then(res=>{
					if(res.data.code==200){
						this.global_set_config=res.data.global_set_config;
						this.set_config=res.data.set_config;
						this.openGlobal=res.data.global_set_config.file_directly_global;
						this.openLocal=res.data.set_config.file_directly_open;
						
						if(this.codeType==1){//视频
							this.downlodGlobal=res.data.global_set_config.download_tag;
							this.downlodLocal=res.data.set_config.video_download_code;
						}else if(this.codeType==4){//文件
							this.downlodGlobal=res.data.global_set_config.file_download_global;
							this.downlodLocal=res.data.set_config.file_download_part;
						}
						
					}
				}).catch(err => {
				});
			},
			setDownloadset(type){
				// var global_set_config={
				// 	share:1,//1：开启分享 2：关闭分享
				// 	colloct:1,//1:开启收藏 2：关闭收藏
				// 	footer_tag:1,//1:开启底部官网标识 2：关闭底部标识
				// 	view_tag:2,//1：开启阅读量 2：关闭阅读量
				// 	download_tag:0,//1：开启视频下载 2：关闭视频下载
				// 	file_download_global:0,//1：开启文件下载 2：关闭文件下载
				// }
				// var set_config={
				// 	uid:'',//指定成员 空未指定 默认第一个微信扫码的人
				// 	editable:2,//判断是否可以编辑 1当前用户可进行编辑
				// 	edit_sta:2,//编辑状态 1：正在编辑 2：未编辑
				// 	edit_number:0,//允许编辑次数 0不限次数
				// 	edit_allowed:1,//是否允许手机扫码编辑 1：允许 2不允许
				// 	start_time: 0,
				// 	end_time : 0,
				// 	time : 0,
				// 	start_time_quantum : 0,
				// 	end_time_quantum : 0,
				// 	psw_tip : '',
				// 	password : '',
				// 	encryption : 2,
				// 	time_horizon : 2,
				// 	other_app : 1,//允许非微信打开
				// 	chat_app : 1,//允许微信打开
				// 	press : 1,//允许长按识别进入
				// 	scan : 1,//允许扫码进入
				// 	share : 1,//允许微信分享进入
				// 	mode:1,//1默认微微小程序 2：无标识小程序  3：h5展示
				// 	video_download_code:0,//视频独立下载，0：未设置，1：可以下载 2：禁止下载
				// 	file_download_part:0,//文件独立下载，0：未设置，1：可以下载 2：关闭下载
				// }
				var global_set_config=this.global_set_config;
				var set_config=this.set_config;
				if(this.codeType==1){//视频
					global_set_config.download_tag=this.downlodGlobal
					set_config.video_download_code=this.downlodLocal
				}else if(this.codeType==4){//文件
					global_set_config.file_download_global=this.downlodGlobal
					set_config.file_download_part=this.downlodLocal
				}
				this.downlodsetLoading=true;
				this.$apiRequest.post('/qrcode/create/changeSet',{
					type:2,//1查询2修改
					id_key:this.id_key,
					change_type:this.codeType,
					set_config:JSON.stringify(set_config),
					global_set_config:JSON.stringify(global_set_config)
				}).then(res=>{
					this.downlodsetLoading=false;
					this.downloadModVisible=false;
					if(res.data.code==200){
						message.success(res.data.message)
					}
				}).catch(err => {
					this.downlodsetLoading=false;
					this.downloadModVisible=false;
					this.$baseFunc.checkState({
						code:err.data.code,
						message:err.data.message,
					}).then(res => {
					}).catch(err=>{
						
					});
				});
			},
			setOpenset(type){
				
				var global_set_config=this.global_set_config;
				var set_config=this.set_config;
				global_set_config.file_directly_global=this.openGlobal;
				set_config.file_directly_open=this.openLocal;
				this.opensetLoading=true;
				this.$apiRequest.post('/qrcode/create/changeSet',{
					type:2,//1查询2修改
					id_key:this.id_key,
					change_type:this.codeType,
					set_config:JSON.stringify(set_config),
					global_set_config:JSON.stringify(global_set_config)
				}).then(res=>{
					this.opensetLoading=false;
					this.openModVisible=false;
					if(res.data.code==200){
						message.success(res.data.message)
					}
				}).catch(err => {
					this.opensetLoading=false;
					this.openModVisible=false;
					this.$baseFunc.checkState({
						code:err.data.code,
						message:err.data.message,
					}).then(res => {
					}).catch(err=>{
						
					});
				});
			},
			
			/*二维码美化弹窗*/
			qrcodeBeautifyFuncBtn(){
				this.qrcodeBeautyData.beautifyOpen('beaty');
			},
			beautifyQrcodeFunc(){/*调用二维码美化接口*/
				const _this = this
				this.qrcodeCreateing = true;
				
				if(this.qrcodeConfig.background && !_this.$baseFunc.isBase64(this.qrcodeConfig.background))this.qrcodeConfig.background=_this.$baseFunc.getAliOssAuthKeyLocal(this.qrcodeConfig.background)
				if(this.qrcodeConfig.foreground && !_this.$baseFunc.isBase64(this.qrcodeConfig.background))this.qrcodeConfig.foreground=_this.$baseFunc.getAliOssAuthKeyLocal(this.qrcodeConfig.foreground)
				if(this.qrcodeConfig.logoimg && !_this.$baseFunc.isBase64(this.qrcodeConfig.background))this.qrcodeConfig.logoimg=_this.$baseFunc.getAliOssAuthKeyLocal(this.qrcodeConfig.logoimg)
				
				this.qrcodeBeautifyFunc = new qrcodeBeautifyFuncPackage({
					info:this.qrcodeConfig,
					success:function (res) {
						_this.qrcodeConfig = res.info
						_this.qrcodeConfig.bgwidth = _this.$baseFunc.handleInt(_this.qrcodeConfig.bgwidth);
						_this.saveQrcodeImgPath(res.base64);
					},error:function (err) {
						// console.log("生成错误：",err)
					}
				});
			},
			/*保存二维码到服务器*/
			saveQrcodeImgPath(base64){
				const _this = this
				var qrcodeContent = this.qrcodeContent
				if(typeof this.qrcodeContent.id_key != 'undefined' && this.qrcodeContent.id_key){
					this.$apiRequest.post('/qrcode/create/saveQrcodeImgPath',{
						id_key:this.qrcodeContent.id_key,
						base64:base64,
						qrcodeconfig:JSON.stringify(this.qrcodeConfig),
					}).then(res=>{
						_this.qrcodeImgBase64 = base64
						_this.qrcodeCreateing = false;
					}).catch(err => {
					});
				}else if(typeof this.qrcodeContent.content != 'undefined' && this.qrcodeContent.content){
					_this.qrcodeImgBase64 = base64
					_this.qrcodeCreateing = false;
				}else{
					_this.qrcodeCreateing = false;
				}
			},
			handleChangeCodeSize(){//修改二维码尺寸
				this.qrcodeBeautifyFunc && this.qrcodeBeautifyFunc.changeWidth(this.qrcodeConfig.bgwidth);
			},
			handleChangeCodeLevel(){//修改容错率
				this.qrcodeBeautifyFunc && this.qrcodeBeautifyFunc.changeLevel(this.qrcodeConfig.level);
			},
			
			/*选择完头像后*/
			logoQrcodeChange(e){
				this.qrcodeBeautifyFunc && this.qrcodeBeautifyFunc.changeLogoimg(e,"");
				this.$refs.logoQrcodeRef.value=""
			},
			/*上传logo*/
			uploadLogoQrcodeBeautifyFuncBtn(){
				this.qrcodeBeautyData.beautifyOpen('logo');
				// this.$refs.logoQrcodeRef.dispatchEvent(new MouseEvent('click'))
			},
			saveContent(e) {/*拦截ctrl+s快捷键*/
			    var key = window.event.keyCode ? window.event.keyCode : window.event.which
			    if (key === 83 && e.ctrlKey) {
			        this.downloadBase64ToLocal()
			        e.preventDefault()
			    }
			},
			downloadBase64ToLocal(){/*下载图片到本地*/
				if(!this.qrcodeImgBase64){
					message.warning('请先生成二维码');
				}else{
					this.download.downloadFile(this.qrcodeImgBase64);
				}
			},
			setOpenType(e){
				if(e!=1&&this.userDefultSet.vip_status==0){
					this.getUserDefultSet().then(res=>{
						if(res.vip_status>0){
							this.useSetdata.openType=e;
						}else{
							baseFunc.checkState({code:11001,message:res.mode_message}).then(res=>{}).catch(err => {});
						}
					}).catch(err=>{
						baseFunc.checkState({code:11001,message:this.userDefultSet.mode_message}).then(res=>{}).catch(err => {});
					})
				}else{
					this.useSetdata.openType=e;
				}
			},
			setStyleType(e){
				this.useSetdata.styleType=e
			}
		}
	}
</script>

<style scoped>
	
	.mbm-wenhao-xianxingyuankuang{
		color: #999;
		display: inline-block;
		transform: scale(.9);
	}
	.mbm_move_model_center_footer .ant-btn-primary:hover, .ant-btn-primary:focus{
		background: #40a9ff !important;
		border-color: #40a9ff !important;
	}
	.qrcode-beatful-item /deep/ .ant-select-selector{
		border: 0 !important;
		font-size: 12px !important;
	}
	.imgSetcon /deep/ .ant-modal-body{
		padding: 0;
	}
	.qrcode-beatful-box{
		width: 210px;
		margin: 20px auto 0;
	}
	.qrcode-beatful-item{
		width: 100%;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-top: 10px;
	}
	.qrcode-beatful-box .qrcode-beatful-item:first-child{margin-top: 0}
	.qrcode-beatful-item .qrcode-beatful-item-left{
		color: #585858;
		font-size: 12px;
	}
	.qrcode-beatful-item-left span{font-size: 12px;margin-left: 4px;}
	
	.qrCodebtns .ant-btn:hover{
		color: #09bd71;
		    background: #fff;
		    border-color: #09bd71;
	}
	.detailSet1 span:hover{
		color: #09bd71;
	}
	.detailSet1 span{
		transition: all 0.3s;
		font-size: 12px;
		    color: #38589e;
		    text-decoration: underline;
		    margin-left: 7px;
		    cursor: pointer;
	}
	.detailSetDesc{
		font-size: 12px;
		color: #585858;
		line-height: 12px;
	}
	.detailSet{
		font-size: 14px;
		    line-height: 14px;
		    color: #333;
		    margin-bottom: 22px;
	}
	.videoType{
		display: flex;
	}
	.videoType>div {
		width: 95px;
		height: 32px;
		border: 1px solid #e7e7e7;
		border-radius: 4px;
		font-size: 14px;
		color: #333;
		line-height: 30px;
		text-align: center;
		margin-right: 12px;
		cursor: pointer;
		position: relative;
	}
	.yjy-gou-rb-box{
		position: absolute;
		right:-1px;
		bottom:-1px;
		font-size:20px;
		line-height: 20px;
		color: #09bd71;
	}
	.vip-logo-icon{
		width: 26px;
		height: 18px;
		position: absolute;
		right: 0;
		top: 0;
		color: #fd9f07;
		line-height: 1;
		font-size: 18px;
	}
	.openTypeImg{
		width:17px;
		height:17px;
		margin-right:3px;
	}
	.open__defult__logo__img{
		height: 20px;
		width: auto;
		margin-top: -3px;
	}
	.openType {
		display: flex;
		justify-content: space-between;
	}
	.openType>div:hover{
		border: 1px solid #09bd71;
	}
	.openType>div {
		transition: all 0.3s;
		width: 132px;
		height: 56px;
		border: 1px solid #e7e7e7;
		border-radius: 4px;
		font-size: 14px;
		color: #333;
		line-height: 54px;
		text-align: center;
		cursor: pointer;
		position:relative;
	}
	.operateActive {
		border: 1px solid #09bd71 !important;
	}
	.setTitle{
		font-size: 14px;
		    line-height: 14px;
		    color: #333;
		    margin-top: 22px;
		    margin-bottom: 11px;
	}
	.qrCodeimg{
		width: 100%;
		height: 100%;
		object-fit: contain;
		/* image-rendering: pixelated; */
	}
	.btnsMargin:hover{
		background-color:#f0f0f0 !important;
		color:rgba(0,0,0,.9) !important;
		border-color:#f0f0f0 !important;
	}
	.btnsMargin{
		width: 110px;
		font-size: 13px;
		border-color: #f7f7f7;
		background-color: #f7f7f7;
	}
	.qrCodebtns{
		width: 230px;
		margin: 0 auto;
		display: flex;
		justify-content: space-between;
		margin-top: 15px;
	}
	.qrCodeimgContainer{
		width: 230px;
		height: 230px;
		margin: 0 auto;
		/* padding: 5px; */
		box-shadow: 0 0 6px rgba(0, 0, 0, .05);
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
	}
	.qrCodeimgContainer i{
		font-size: 110px;
		color: #ececec;
	}
	.qrcode-create-loading-item{
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: rgba(214,214,214,0.2);
		color: #09bd71;
		font-size: 30px;
		z-index: 999;
	}
	[class*="loader-defult-yjdhw-"] {display: inline-block;width: 1em;height: 1em;color: inherit;vertical-align: middle;pointer-events: none;}
	.loader-defult-yjdhw-38{height:0.1em;width:0.1em;box-shadow:-0.2em -0.2em 0 0.1em currentcolor,-0.2em -0.2em 0 0.1em currentcolor,-0.2em -0.2em 0 0.1em currentcolor,-0.2em -0.2em 0 0.1em currentcolor;-webkit-animation:loader-defult-yjdhw-38 4s infinite;animation:loader-defult-yjdhw-38 4s infinite}
	@-webkit-keyframes loader-defult-yjdhw-38{0%{box-shadow:-0.2em -0.2em 0 0.1em currentcolor,-0.2em -0.2em 0 0.1em currentcolor,-0.2em -0.2em 0 0.1em currentcolor,-0.2em -0.2em 0 0.1em currentcolor}
	8.33%{box-shadow:-0.2em -0.2em 0 0.1em currentcolor,0.2em -0.2em 0 0.1em currentcolor,0.2em -0.2em 0 0.1em currentcolor,0.2em -0.2em 0 0.1em currentcolor}
	16.66%{box-shadow:-0.2em -0.2em 0 0.1em currentcolor,0.2em -0.2em 0 0.1em currentcolor,0.2em 0.2em 0 0.1em currentcolor,0.2em 0.2em 0 0.1em currentcolor}
	24.99%{box-shadow:-0.2em -0.2em 0 0.1em currentcolor,0.2em -0.2em 0 0.1em currentcolor,0.2em 0.2em 0 0.1em currentcolor,-0.2em 0.2em 0 0.1em currentcolor}
	33.32%{box-shadow:-0.2em -0.2em 0 0.1em currentcolor,0.2em -0.2em 0 0.1em currentcolor,0.2em 0.2em 0 0.1em currentcolor,-0.2em -0.2em 0 0.1em currentcolor}
	41.65%{box-shadow:0.2em -0.2em 0 0.1em currentcolor,0.2em -0.2em 0 0.1em currentcolor,0.2em 0.2em 0 0.1em currentcolor,0.2em -0.2em 0 0.1em currentcolor}
	49.98%{box-shadow:0.2em 0.2em 0 0.1em currentcolor,0.2em 0.2em 0 0.1em currentcolor,0.2em 0.2em 0 0.1em currentcolor,0.2em 0.2em 0 0.1em currentcolor}
	58.31%{box-shadow:-0.2em 0.2em 0 0.1em currentcolor,-0.2em 0.2em 0 0.1em currentcolor,0.2em 0.2em 0 0.1em currentcolor,-0.2em 0.2em 0 0.1em currentcolor}
	66.64%{box-shadow:-0.2em -0.2em 0 0.1em currentcolor,-0.2em -0.2em 0 0.1em currentcolor,0.2em 0.2em 0 0.1em currentcolor,-0.2em 0.2em 0 0.1em currentcolor}
	74.97%{box-shadow:-0.2em -0.2em 0 0.1em currentcolor,0.2em -0.2em 0 0.1em currentcolor,0.2em 0.2em 0 0.1em currentcolor,-0.2em 0.2em 0 0.1em currentcolor}
	83.3%{box-shadow:-0.2em -0.2em 0 0.1em currentcolor,0.2em 0.2em 0 0.1em currentcolor,0.2em 0.2em 0 0.1em currentcolor,-0.2em 0.2em 0 0.1em currentcolor}
	91.63%{box-shadow:-0.2em -0.2em 0 0.1em currentcolor,-0.2em 0.2em 0 0.1em currentcolor,-0.2em 0.2em 0 0.1em currentcolor,-0.2em 0.2em 0 0.1em currentcolor}
	100%{box-shadow:-0.2em -0.2em 0 0.1em currentcolor,-0.2em -0.2em 0 0.1em currentcolor,-0.2em -0.2em 0 0.1em currentcolor,-0.2em -0.2em 0 0.1em currentcolor}
	}@keyframes loader-defult-yjdhw-38{0%{box-shadow:-0.2em -0.2em 0 0.1em currentcolor,-0.2em -0.2em 0 0.1em currentcolor,-0.2em -0.2em 0 0.1em currentcolor,-0.2em -0.2em 0 0.1em currentcolor}
	8.33%{box-shadow:-0.2em -0.2em 0 0.1em currentcolor,0.2em -0.2em 0 0.1em currentcolor,0.2em -0.2em 0 0.1em currentcolor,0.2em -0.2em 0 0.1em currentcolor}
	16.66%{box-shadow:-0.2em -0.2em 0 0.1em currentcolor,0.2em -0.2em 0 0.1em currentcolor,0.2em 0.2em 0 0.1em currentcolor,0.2em 0.2em 0 0.1em currentcolor}
	24.99%{box-shadow:-0.2em -0.2em 0 0.1em currentcolor,0.2em -0.2em 0 0.1em currentcolor,0.2em 0.2em 0 0.1em currentcolor,-0.2em 0.2em 0 0.1em currentcolor}
	33.32%{box-shadow:-0.2em -0.2em 0 0.1em currentcolor,0.2em -0.2em 0 0.1em currentcolor,0.2em 0.2em 0 0.1em currentcolor,-0.2em -0.2em 0 0.1em currentcolor}
	41.65%{box-shadow:0.2em -0.2em 0 0.1em currentcolor,0.2em -0.2em 0 0.1em currentcolor,0.2em 0.2em 0 0.1em currentcolor,0.2em -0.2em 0 0.1em currentcolor}
	49.98%{box-shadow:0.2em 0.2em 0 0.1em currentcolor,0.2em 0.2em 0 0.1em currentcolor,0.2em 0.2em 0 0.1em currentcolor,0.2em 0.2em 0 0.1em currentcolor}
	58.31%{box-shadow:-0.2em 0.2em 0 0.1em currentcolor,-0.2em 0.2em 0 0.1em currentcolor,0.2em 0.2em 0 0.1em currentcolor,-0.2em 0.2em 0 0.1em currentcolor}
	66.64%{box-shadow:-0.2em -0.2em 0 0.1em currentcolor,-0.2em -0.2em 0 0.1em currentcolor,0.2em 0.2em 0 0.1em currentcolor,-0.2em 0.2em 0 0.1em currentcolor}
	74.97%{box-shadow:-0.2em -0.2em 0 0.1em currentcolor,0.2em -0.2em 0 0.1em currentcolor,0.2em 0.2em 0 0.1em currentcolor,-0.2em 0.2em 0 0.1em currentcolor}
	83.3%{box-shadow:-0.2em -0.2em 0 0.1em currentcolor,0.2em 0.2em 0 0.1em currentcolor,0.2em 0.2em 0 0.1em currentcolor,-0.2em 0.2em 0 0.1em currentcolor}
	91.63%{box-shadow:-0.2em -0.2em 0 0.1em currentcolor,-0.2em 0.2em 0 0.1em currentcolor,-0.2em 0.2em 0 0.1em currentcolor,-0.2em 0.2em 0 0.1em currentcolor}
	100%{box-shadow:-0.2em -0.2em 0 0.1em currentcolor,-0.2em -0.2em 0 0.1em currentcolor,-0.2em -0.2em 0 0.1em currentcolor,-0.2em -0.2em 0 0.1em currentcolor}
	}
	.qrCodeContainer{
		
	}
	.modContainer{
		width: 100%;
		padding: 30px 23px 0;
	}
	.download-orther-ext-jxuhs{color: rgba(0,0,0,0.65);font-size: 14px;text-align: center;width: 100%;margin: 12px 0;cursor: pointer;transition: color 0.2s;}
	.download-orther-ext-jxuhs:hover{color:#09bd71;}
</style>
